enum Role {
  Admin = 'ADMIN',
  Reviewer = 'REVIEWER',
  CompanyAdmin = 'COMPANY_ADMIN',
  BuildingManager = 'BUILDING_MANAGER',
  PropertyAdmin = 'PROPERTY_ADMIN',
  OnSiteRepresentative = 'ON_SITE_REPRESENTATIVE',
  FraudAnalyst = 'FRAUD_ANALYST',
  FdeManager = 'FDE_MANAGER',
  SeniorFraudAnalyst = 'SENIOR_FRAUD_ANALYST',
  ExternalClient = 'EXTERNAL_CLIENT',
  AccountRepresentative = 'ACCOUNT_REPRESENTATIVE',
  Owner = 'OWNER',
  PartnerAdmin = 'PARTNER_ADMIN'
}

export { Role as RoleEnum, Role as Roles };
